import React from 'react';
import { AppGlobals } from '../AppGlobals';
import useMobileDetector from './useMobileDetector';

export const LoggedUserInfoForMenu = (): React.ReactElement => {
    const isMobile = useMobileDetector();

    if (isMobile) {
        // --- MOBILE VIEW ---
        return (
            <div className="menu-logged-user-info">
                Logged in as {AppGlobals.UserTitle} ({AppGlobals.CustomerTitle})
            </div>
        );
    }

    // --- DESKTOP VIEW ---
    return (
        <div style={{ paddingLeft: '20px', paddingRight: '20px', paddingBottom: '20px', paddingTop: '7px' }}>
            <div>{AppGlobals.UserTitle}</div>
            <div style={{ fontStyle: 'italic' }}>{AppGlobals.CustomerTitle}</div>
        </div>
    );
};
